export default {
  "languages": {
    "en": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["English"])},
    "es": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Español"])},
    "it": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Italiano"])}
  },
  "labels": {
    "cancel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Cancel"])},
    "back": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Back"])},
    "continue": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Continue"])},
    "save": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Save"])},
    "page-title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["DT Modeller"])},
    "page-section": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Conversion model"])},
    "conversion-description": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Convert the model to a standard. Select the export standard."])},
    "select-standards": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Select the standards"])},
    "select-standard-display": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Select standard to display"])},
    "output-standard": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Standard output"])},
    "validation-standard": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Validation of the standard"])},
    "no-standard-selected": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["No standard selected"])},
    "select-standard-to-generate": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Select a standard to generate output and display any alerts"])},
    "export": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Export"])},
    "rename": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Rename"])},
    "delete": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Delete"])}
  },
  "strings": {
    "validation-title-success": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Export completed successfully!"])},
    "validation-description-success": {
      "dtdl": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["The model has been successfully exported to DTDL format."])},
      "ngsild": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["The model has been successfully exported to NGSI-LD format."])}
    },
    "validation-title-warning": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Export completed - model not up to date"])},
    "validation-description-warning": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["The exported model is an earlier version and may not include the latest changes."])}
  },
  "errors": {
    "generic": {
      "title-msg": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Unexpected error"])},
      "message-msg": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["An unexpected error occurred while processing your request."])}
    },
    "outdated-entities": {
      "title-msg": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Entity not updated"])},
      "message-msg": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["The model is invalid, some entities are not up to date."])}
    }
  }
}